import React from 'react';
import PropTypes from 'prop-types';

import Style from './seatMapPopOver.module.css';

export default function SeatMapPopOver({ title = null, children = null, className = '', ...rest }) {
    return (
        <div className={`${Style['seat-map-popover']} seat-map-popover ${className}`} {...rest}>
            <div className={`${Style['title']}`}>{title}</div>
            <div className={`${Style['content']} content`}>{children}</div>
        </div>
    );
}

SeatMapPopOver.propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string
};
